import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import CTABanner from "../components/CTABanner";
import { useSEO } from "../hooks/useSEO";
import { services } from "../data/services";

export default function Services() {
  useSEO({
    title: "Nos services — Entretien de jardins, taille de haies, aménagement | Embèk Group",
    description:
      "Entretien de jardins, tonte de pelouse, désherbage, taille de haies et élagage, création et aménagement paysager, pose de gazon, nettoyage extérieur : découvrez toutes les prestations d'Embèk Group.",
  });

  return (
    <>
      <PageHeader
        eyebrow="Nos services"
        title="Tout pour vos espaces verts"
        description="Entretien, taille, création, pelouses, nettoyage : une offre complète pour un extérieur impeccable toute l'année."
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 space-y-20 lg:space-y-28">
          {services.map((s, i) => (
            <div
              key={s.id}
              id={s.id}
              data-testid={`service-detail-${s.id}`}
              className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}
            >
              <Reveal className="lg:[direction:ltr]">
                <div className="rounded-3xl overflow-hidden shadow-xl shadow-forest/10 aspect-[4/3] group">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </Reveal>
              <div className="lg:[direction:ltr]">
                <Reveal>
                  <span className="font-serif text-6xl font-light text-moss/30 leading-none">0{i + 1}</span>
                  <h2 className="mt-3 font-serif text-3xl sm:text-4xl font-medium tracking-tight text-forest">{s.title}</h2>
                  <p className="mt-4 text-coal-muted font-light leading-relaxed">{s.description}</p>
                </Reveal>
                <Reveal delay={0.1}>
                  <ul className="mt-6 grid sm:grid-cols-2 gap-2.5">
                    {s.subs.map((sub) => (
                      <li key={sub} className="flex items-center gap-2.5 text-sm font-medium text-forest">
                        <span className="w-5 h-5 rounded-full bg-moss/15 text-moss flex items-center justify-center shrink-0">
                          <Check size={11} strokeWidth={3} />
                        </span>
                        {sub}
                      </li>
                    ))}
                  </ul>
                </Reveal>
                <Reveal delay={0.15}>
                  <Link to="/demander-un-devis" data-testid={`service-devis-${s.id}`} className="btn-outline-forest mt-8">
                    Demander un devis <ArrowRight size={15} />
                  </Link>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABanner />
    </>
  );
}
